export default {
  // 页面标题和面包屑
  'pages.moveout.title': '搬出登记管理',
  'pages.moveout.breadcrumb.person': '人员管理',
  'pages.moveout.breadcrumb.moveout': '搬出登记',

  // 副标题配置
  'pages.moveout.subtitle.canEnterEarly': '审核通过后，可以提前',
  'pages.moveout.subtitle.hoursEnter': '小时进入，如果超过',
  'pages.moveout.subtitle.hoursCannotEnter': '小时后将无法进入小区',

  // 按钮
  'pages.moveout.button.settings': '设置',

  // 标签页
  'pages.moveout.tabs.registered': '已登记',
  'pages.moveout.tabs.inProgress': '进行中',
  'pages.moveout.tabs.completed': '已完成',

  // 模态框
  'pages.moveout.modal.config.title': '搬出时间配置',
  'pages.moveout.modal.config.save': '保存',
  'pages.moveout.modal.config.cancel': '取消',

  // 表单标签
  'pages.moveout.form.beforeHours.label': '提前进入时间（小时）',
  'pages.moveout.form.beforeHours.placeholder': '请输入提前进入时间',
  'pages.moveout.form.beforeHours.required': '请输入提前进入时间',
  'pages.moveout.form.beforeHours.range': '请输入0-24之间的数字',

  'pages.moveout.form.afterHours.label': '超时限制时间（小时）',
  'pages.moveout.form.afterHours.placeholder': '请输入超时限制时间',
  'pages.moveout.form.afterHours.required': '请输入超时限制时间',
  'pages.moveout.form.afterHours.range': '请输入1-168之间的数字',

  // 消息
  'pages.moveout.message.configUpdateSuccess': '配置更新成功',
  'pages.moveout.message.configUpdateFailed': '配置更新失败',

  // 表格相关
  'pages.moveout.table.title': '搬出登记管理',
  'pages.moveout.table.columns.houseInfo': '房屋信息',
  'pages.moveout.table.columns.applicantName': '申请人姓名',
  'pages.moveout.table.columns.applicantPhone': '申请人手机号',
  'pages.moveout.table.columns.qrcode': '二维码',
  'pages.moveout.table.columns.ownerName': '业主姓名',
  'pages.moveout.table.columns.startDate': '搬出开始日期',
  'pages.moveout.table.columns.endDate': '搬出结束日期',
  'pages.moveout.table.columns.status': '状态',
  'pages.moveout.table.columns.moveoutList': '搬出清单',
  'pages.moveout.table.columns.createdTime': '创建时间',
  'pages.moveout.table.columns.action': '操作',

  // 按钮
  'pages.moveout.button.create': '新增搬出登记',
  'pages.moveout.button.view': '查看',
  'pages.moveout.button.edit': '编辑',
  'pages.moveout.button.delete': '删除',
  'pages.moveout.button.batchDelete': '批量删除',
  'pages.moveout.button.close': '关闭',

  // 状态
  'pages.moveout.status.notStarted': '未开始',
  'pages.moveout.status.inProgress': '进行中',
  'pages.moveout.status.completed': '已完成',
  'pages.moveout.status.unknown': '未知',

  // 详情模态框
  'pages.moveout.detail.title': '搬出登记详情',
  'pages.moveout.detail.sections.houseInfo': '房屋信息',
  'pages.moveout.detail.sections.applicantInfo': '申请人信息',
  'pages.moveout.detail.sections.moveoutInfo': '搬出信息',
  'pages.moveout.detail.sections.remarks': '备注信息',
  'pages.moveout.detail.sections.systemInfo': '系统信息',

  // 字段标签
  'pages.moveout.detail.fields.buildingName': '楼栋名称',
  'pages.moveout.detail.fields.floor': '楼层',
  'pages.moveout.detail.fields.houseNumber': '房号',
  'pages.moveout.detail.fields.applicantName': '申请人姓名',
  'pages.moveout.detail.fields.applicantPhone': '申请人手机号',
  'pages.moveout.detail.fields.ownerName': '业主姓名',
  'pages.moveout.detail.fields.ownerPhone': '业主电话',
  'pages.moveout.detail.fields.startDate': '搬出开始日期',
  'pages.moveout.detail.fields.endDate': '搬出结束日期',
  'pages.moveout.detail.fields.moveoutList': '搬出清单',
  'pages.moveout.detail.fields.moveoutStatus': '搬出状态',
  'pages.moveout.detail.fields.remarks': '备注',
  'pages.moveout.detail.fields.createdTime': '创建时间',
  'pages.moveout.detail.fields.updatedTime': '更新时间',

  // 编辑/创建表单
  'pages.moveout.form.create.title': '新增搬出登记',
  'pages.moveout.form.edit.title': '编辑搬出登记',
  'pages.moveout.form.submit.create': '创建',
  'pages.moveout.form.submit.update': '更新',
  'pages.moveout.form.submit.cancel': '取消',

  // 表单分区
  'pages.moveout.form.sections.houseInfo': '房屋信息',
  'pages.moveout.form.sections.moveoutInfo': '搬出信息',
  'pages.moveout.form.sections.moveoutList': '搬出清单',
  'pages.moveout.form.sections.remarks': '备注信息',

  // 表单字段
  'pages.moveout.form.fields.houseInfo.label': '房屋信息',
  'pages.moveout.form.fields.houseInfo.placeholder': '请选择房屋',
  'pages.moveout.form.fields.houseInfo.search': '查询',
  'pages.moveout.form.fields.houseInfo.select': '选择房屋后自动填充',
  'pages.moveout.form.fields.houseInfo.required': '请选择房屋',

  'pages.moveout.form.fields.ownerInfo.label': '房主姓名',
  'pages.moveout.form.fields.ownerInfo.placeholder': '选择房屋后自动填充',

  'pages.moveout.form.fields.applicantName.label': '申请人姓名',
  'pages.moveout.form.fields.applicantName.placeholder': '请输入申请人姓名',
  'pages.moveout.form.fields.applicantName.required': '请输入申请人姓名',
  'pages.moveout.form.fields.applicantName.maxLength': '申请人姓名不能超过50个字符',

  'pages.moveout.form.fields.applicantPhone.label': '申请人手机号',
  'pages.moveout.form.fields.applicantPhone.placeholder': '请输入申请人手机号',
  'pages.moveout.form.fields.applicantPhone.required': '请输入申请人手机号',

  'pages.moveout.form.fields.moveoutTime.label': '搬出时间',
  'pages.moveout.form.fields.moveoutTime.placeholder': ['开始日期', '结束日期'],
  'pages.moveout.form.fields.moveoutTime.required': '请选择搬出时间',

  'pages.moveout.form.fields.moveoutList.label': '搬出清单',
  'pages.moveout.form.fields.moveoutList.required': '请至少添加一条搬出清单',
  'pages.moveout.form.fields.moveoutList.notEmpty': '搬出清单项不能为空',
  'pages.moveout.form.fields.moveoutList.placeholder': '请输入清单内容',

  'pages.moveout.form.fields.remarks.label': '备注',
  'pages.moveout.form.fields.remarks.placeholder': '请输入备注信息',

  // 表格列
  'pages.moveout.form.table.columns.serialNumber': '序号',
  'pages.moveout.form.table.columns.content': '清单内容',
  'pages.moveout.form.table.columns.action': '操作',

  // 按钮
  'pages.moveout.form.button.addItem': '添加清单项',
  'pages.moveout.form.button.delete': '删除',

  // 消息提示
  'pages.moveout.message.create.success': '搬出登记创建成功',
  'pages.moveout.message.create.failed': '创建失败，请稍后重试',
  'pages.moveout.message.update.success': '搬出登记更新成功',
  'pages.moveout.message.update.failed': '更新失败，请稍后重试',
  'pages.moveout.message.delete.success': '删除成功',
  'pages.moveout.message.delete.failed': '删除失败',
  'pages.moveout.message.batchDelete.success': '批量删除成功',
  'pages.moveout.message.batchDelete.failed': '批量删除失败',
  'pages.moveout.message.houseSelect.success': '房屋信息已自动填充',
  'pages.moveout.message.qrCode.configError': '二维码URL配置不完整',
  'pages.moveout.message.qrCode.downloadSuccess': '二维码已下载',
  'pages.moveout.message.qrCode.copySuccess': '二维码已复制到剪贴板',
  'pages.moveout.message.qrCode.copyFailed': '复制失败，请使用下载功能',
  'pages.moveout.message.qrCode.elementNotFound': '二维码元素未找到',
  'pages.moveout.message.qrCode.copyFailedAlternative': '复制失败，请使用下载功能或尝试手动操作',
  'pages.moveout.message.listLoadFailed': '获取搬出登记列表失败',

  // 确认对话框
  'pages.moveout.confirm.delete': '确定要删除这条搬出登记记录吗？',
  'pages.moveout.confirm.deleteItem': '确定要删除这条清单吗？',
  'pages.moveout.confirm.batchDelete': '确定要删除选中的 {count} 条记录吗？',
  'pages.moveout.confirm.delete.okText': '确定',
  'pages.moveout.confirm.delete.cancelText': '取消',

  // 二维码相关
  'pages.moveout.qrCode.title': '搬出登记二维码',
  'pages.moveout.qrCode.openLink': '打开链接',
  'pages.moveout.qrCode.copy': '复制二维码',
  'pages.moveout.qrCode.download': '下载二维码',
  'pages.moveout.qrCode.linkLabel': '链接地址：',

  // 表格分页
  'pages.moveout.table.pagination.total': '共 {total} 条记录',

  // Tooltip
  'pages.moveout.tooltip.viewDetail': '查看详情',
  'pages.moveout.tooltip.edit': '编辑',
  'pages.moveout.tooltip.delete': '删除',
  'pages.moveout.tooltip.generateQrCode': '生成二维码',

  // 警告消息
  'pages.moveout.warning.selectRecords': '请选择要删除的记录',
};
